/**
 * Public path for a programmatic SEO page — mirrors backend seo_ssr.programmatic_canonical().
 */
export function programmaticPagePath(page) {
    if (!page?.slug) return null;
    if (page.canonical_url) {
        try {
            const u = new URL(page.canonical_url, window.location.origin);
            return u.pathname;
        } catch {
            return page.canonical_url.startsWith('/') ? page.canonical_url : `/${page.canonical_url}`;
        }
    }

    const { page_type: pt, slug, city_slug: city } = page;

    if ((pt === 'city_config' || pt === 'city_budget') && city) {
        return `/city/${city}/${slug}`;
    }
    if (pt === 'nearby_landmark' && city) {
        const landmark = page.landmark_slug || slug.replace(/^near-/, '');
        return `/city/${city}/near/${landmark}`;
    }
    if (pt === 'new_launch' && city) {
        return `/city/${city}/new-launch-projects`;
    }
    if (pt === 'comparison') {
        return `/compare/${slug}`;
    }
    return `/guides/${slug}`;
}

export function programmaticPageUrl(page) {
    const path = programmaticPagePath(page);
    if (!path) return null;
    if (typeof window !== 'undefined') {
        return `${window.location.origin}${path}`;
    }
    return path;
}
